import React from 'react';
import * as logger from '../logging/logger';

interface ErrorBoundaryProps {
    children: any;
    errorComponent: () => any;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        logger.log('Error', `ReactErrorBoundary: ${error.message} ${JSON.stringify(errorInfo)}`);
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorComponent();
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
